<p-toast position="top-right"></p-toast>

<div class="roster-code-setting-page">
  <div class="text-center roster-code-setting-toolbar">
    <button pButton pRipple label="Save Changes" class="p-button-primary p-mr-2" icon="pi pi-save" [disabled]="!shouldEnableSave()" (click)="saveChanges()"></button>
    <button pButton pRipple label="Dicard Changes" class="p-button-danger p-mr-2" icon="pi pi-trash" [disabled]="!shouldEnableSave()" (click)="discardChanges()"></button>
  </div>

  <div class="roster-code-setting-scroll">
    <div class="p-grid roster-code-setting p-d-block">
      <p-table 
              [value]="rosterCodes"             
              styleClass="p-datatable-gridlines p-offset-3 p-col-6">
        <ng-template pTemplate="header">
          <tr>
            <th style="min-width:60px" class="bg-header">Roster Code</th>
            <th class="bg-header"></th>
            <th class="bg-header">Text Color</th>
            <th class="bg-header">Background Color</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rosterCode let-rowIndex="rowIndex">
          <tr *ngFor="let rcs of rosterCode; let index=index">
            <td *ngIf="index === 0" 
                [attr.rowSpan]="rosterCode.length"
                [style.background]="rowIndex % 2 ? '#fafafa' : '#ffffff'"
                style="vertical-align: top;min-width:60px">
              <span class="p-text-bold p-ml-2">
                {{rcs.rosterCode.code}}
              </span>
            </td>
            <td [style.background]="rowIndex % 2 ? '#fafafa' : '#ffffff'">
              {{rcs.description === null ? rcs.rosterCode.description : rcs.rosterCode.description + " - " + rcs.description }}
            </td>
            <td [style.background]="rowIndex % 2 ? '#fafafa' : '#ffffff'">
              <input readonly
                [cpWidth]="250"
                [value]="rcs.rosterCode.code"
                [style]="{backgroundColor: rcs.backgroundColor, color: rcs.foregroundColor, width:'120px', height:'30px', textAlign:'center', border: '1px solid #cccccc'}"
                [cpPresetColors]="presetColors"
                [cpPosition]="'left'"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [(colorPicker)]="rcs.foregroundColor"
                (colorPickerChange)="changeForeColor(rcs)"/>
            </td>
            <td [style.background]="rowIndex % 2 ? '#fafafa' : '#ffffff'">
              <input readonly
                [value]="rcs.rosterCode.code"
                [style]="{backgroundColor: rcs.backgroundColor, color: rcs.foregroundColor, width:'120px', height:'30px', textAlign:'center', border: '1px solid #cccccc'}"
                [cpPresetColors]="presetColors"
                [cpPosition]="'right'"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [(colorPicker)]="rcs.backgroundColor"
                (colorPickerChange)="changeBackColor(rcs)"/>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
